module.exports = __webpack_public_path__ + "static/img/school_msg.3fa29eba.jpg";